import { useEffect, useState } from 'react'
import { useDebouncedValue } from './useDebouncedValue'
import { userSearchService } from '@/services/userSearchService'
import { User } from '@/types/user'

export function useUserSearch(query: string, delayMs: number = 300) {
  const debouncedQuery = useDebouncedValue(query, delayMs)
  const [results, setResults] = useState<User[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const trimmed = debouncedQuery.trim()

    if (!trimmed) {
      setResults([])
      setIsLoading(false)
      setError(null)
      return
    }

    let cancelled = false
    setIsLoading(true)
    setError(null)

    userSearchService
      .searchUsers(trimmed)
      .then((users) => {
        if (!cancelled) {
          setResults(users)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError('Failed to search users')
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [debouncedQuery])

  return { results, isLoading, error }
}
